import React, { useEffect, useState } from 'react';
import PermissionModal from '../Modals/PermissionModal';
import SweetAlert from '../Shared/Notification';
import APIService from '../../Services/APIService';
import {Button} from 'react-bootstrap'


const PermissionList = () => {
  const [list, setList] = useState([]);
  const [profilePermission, setProfilePermission] = useState();
  const [state, setState] = useState({
    showPermissionModal: false,
    modalProfileId: undefined,
    createPermission: false,
    dataInfo: [],
    profilePermissionId: undefined,
    existingProfileIds: [],
  });

  const getPermissionList = async () => {
    let res = await APIService.get(`/v0/ui/checklists/permissions/`);
    if (res.status == 200) {
      setList(res.data);
    }
  };

  useEffect(() => {
    getPermissionList();
  }, [state.showPermissionModal]);

  const handleEditProfile = async (profileId) => {
    // this.props.getProfilePermission(profileId);
    setState({
      ...state,
      showPermissionModal: true,
      modalProfileId: profileId,
      createPermission: false,
    });
  };

  const handleDeleteProfile = async (permissionId) => {
    let res = await APIService.remove(
      `/v0/ui/checklists/permissions?permission_id=${permissionId}`
    );
    if (res.status == 200) {
      SweetAlert('Profile Checklist Permission deleted successfully', 'success');
    }
  };

  const closePermissionModal = () => {
    setState({
      ...state,
      showPermissionModal: false,
      modalProfileId: undefined,
      createPermission: false,
    });
  };

  const getAllChecklistData = async () => {
    let res = await APIService.get(`/v0/ui/checklists/list_all_checklists/`);
    if (res.status == 200) {
      let checklistData = res.data;
      let profilePermission = [];
      checklistData.forEach((campaignInfo) => {
        let campaignPermissionType = 'None';
        let permissionObject = {
          supplierName: campaignInfo.campaign_name,
          supplierId: campaignInfo.campaign_id,
          type: 'campaign',
          permission: campaignPermissionType,
          data: [],
        };
        if (campaignInfo.checklists.length) {
          campaignInfo.checklists.forEach((checklist) => {
            let checklistPermissionType = 'None';
            let permissionChecklistObject = {
              supplierName: checklist.checklist_name,
              supplierId: checklist.checklist_id,
              type: 'checklist',
              permission: checklistPermissionType,
            };
            permissionObject.data.push(permissionChecklistObject);
          });
        }
        profilePermission.push(permissionObject);
      });
      setProfilePermission(profilePermission);
    }
  };
  const openCreatePermissionModal = async () => {
    // await getAllChecklistData();
    let existingProfileIds = [];
    if (list && list.length) {
      list.forEach((permission) => {
        existingProfileIds.push(permission.profile_id.id);
      });
    }

    setState({
      ...state,
      showPermissionModal: true,
      existingProfileIds,
      createPermission: true,
      modalProfileId: undefined,
    });
  };

  const onModalSubmit = async (stateData) => {
    let requestData = {
      id: undefined,
      checklist_permissions: {
        campaigns: {},
        checklists: {},
      },
      profile_id: undefined,
    };
    if (!state.createPermission) {
      requestData.id = state.profilePermissionId;
      requestData.profile_id = state.modalProfileId;
    } else {
      requestData.profile_id = stateData.selectedProfile.value;
    }

    stateData.data.data.forEach((campaignData) => {
      if (campaignData.type === 'campaign' && campaignData.permission !== 'None') {
        if (campaignData.permission === 'Edit') {
          requestData.checklist_permissions.campaigns[campaignData.supplierId] = [
            'EDIT',
            'VIEW',
            'DELETE',
            'FILL',
            'FREEZE',
            'UNFREEZE',
          ];
        } else {
          requestData.checklist_permissions.campaigns[campaignData.supplierId] = [
            'VIEW',
            'FILL',
            'FREEZE',
          ];
        }
      }
      if (campaignData.data.length) {
        campaignData.data.forEach((checklistData) => {
          if (checklistData.type === 'checklist' && checklistData.permission !== 'None') {
            if (checklistData.permission === 'Edit') {
              requestData.checklist_permissions.checklists[checklistData.supplierId] = [
                'EDIT',
                'VIEW',
                'DELETE',
                'FILL',
                'FREEZE',
                'UNFREEZE',
              ];
            } else {
              requestData.checklist_permissions.checklists[checklistData.supplierId] = [
                'VIEW',
                'FILL',
                'FREEZE',
              ];
            }
          }
        });
      }
    });

    setState({
      ...state,
      showPermissionModal: false,
      modalProfileId: undefined,
      createPermission: false,
    });
    let data = [requestData];
    if (state.createPermission) {
      let res = await APIService.post(`/v0/ui/checklists/permissions/`, data);
      if (res.status == 200) SweetAlert('Profile Permission created successfully', 'success');
    } else {
      let res = await APIService.put(`/v0/ui/checklists/permissions/`, data);
      if (res.status == 200) SweetAlert('Profile Permission updated successfully', 'success');
    }
  };

  const renderPermissionRow = (permission, index) => {
    console.log('permission----------', permission);
    return (
      <>
        <tr key={permission.id}>
          <td>{index + 1}</td>
          <td>{permission.profile_id.name}</td>
          <td>Custom</td>
          <td>{permission.created_by.first_name + ' ' + permission.created_by.last_name}</td>
          <td>
            {/*<Button
              type="button"
              className="btn btn--danger"
              onClick={() => handleEditProfile(permission.profile_id.id)}
            >
              Edit
            </Button>{' '}
            <Button
              type="button"
              className="btn btn--danger"
              onClick={() => handleDeleteProfile(permission.id)}
            >
              Remove
            </Button> */}
            <span
              style={{ cursor: 'pointer'}}
              onClick={() =>  handleEditProfile(permission.profile_id.id)}
            >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
              </span>
           <span
              style={{ cursor: 'pointer' }}
              onClick={(e) => handleDeleteProfile(permission.id)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash-fill"
                viewBox="0 0 16 16"
              >
                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
              </svg>
            </span>
          </td>
        </tr>
      </>
    );
  };

  return (
    <div className="list">
      <div className="list__title">
        <h3>Permission List</h3>
      </div>
      <div className="list__table">
        <table cellPadding="0" cellSpacing="0">
          <thead>
            <tr>
              <th>Index</th>
              <th>Name</th>
              <th>Permission</th>
              <th>Created by</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {console.log('list--------', list)}
            {list && list.length ? (
              list.map(renderPermissionRow)
            ) : (
              <tr>
                <td colSpan="5">No permissions available!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="list__actions">
        <Button type="button" className="btn btn-primary" onClick={openCreatePermissionModal}>
          Create
        </Button>
      </div>
      {state.showPermissionModal ? (
        <PermissionModal
          // {...this.props}
          {...state}
          onClose={closePermissionModal}
          onSubmit={onModalSubmit}
        />
      ) : (
        ''
      )}
    </div>
  );
};
export default PermissionList;


